import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { getImageUrl } from "@/lib/api";
import { formatPrice } from "@/constants/data";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";

const ListingCard = ({ listing }) => {
  const cover = listing.showcase_image || listing.images?.[0];
  return (
    <Link
      to={`/ilan/${listing.id}`}
      data-testid="listing-card"
      className="group rounded-[14px] border border-[color:var(--line)] bg-[color:hsl(var(--card))] overflow-hidden shadow-[0_10px_30px_rgba(43,43,43,0.06)] hover:shadow-[0_16px_44px_rgba(43,43,43,0.10)] transition-shadow duration-200 flex flex-col"
    >
      <AspectRatio ratio={4 / 3} className="overflow-hidden bg-[color:hsl(var(--secondary))]">
        {cover ? (
          <img
            src={getImageUrl(cover)}
            alt={listing.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-sm text-[color:hsl(var(--muted-foreground))]">Görsel yok</div>
        )}
        <Badge className="absolute top-3 left-3 bg-[color:hsl(var(--card))]/95 text-[color:var(--brand-charcoal)] border border-[color:var(--line)] font-medium hover:bg-[color:hsl(var(--card))]/95">
          {listing.listing_type === "satilik" ? "Satılık" : "Kiralık"}
        </Badge>
      </AspectRatio>
      <div className="p-4 flex flex-col gap-1.5 flex-1">
        <h3 data-testid="listing-card-title" className="font-[var(--font-serif)] text-lg leading-snug text-[color:var(--brand-charcoal)] line-clamp-2">
          {listing.title}
        </h3>
        <p data-testid="listing-card-price" className="text-base font-semibold text-[color:var(--brand-charcoal)]">
          {formatPrice(listing.price, listing.currency)}
        </p>
        <p className="text-sm text-[color:hsl(var(--muted-foreground))] flex items-center gap-1 mt-auto">
          <MapPin className="h-3.5 w-3.5 shrink-0" /> {listing.location_text}
        </p>
      </div>
    </Link>
  );
};

export default ListingCard;
